import { Api } from "../api";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import { apiConfig } from "@/services/api/api.config";
import { ILoginInfoCommand } from "@/services/api/models/LoginInfoCommand.model";
import { ILoginCommand } from "@/services/api/models/LoginCommand.model";
import { ILoginTwoFactorCommand } from "@/services/api/models/LoginTwoFactorCommand.model";
import { IRegisterCommand } from "@/services/api/models/RegisterCommand.model";
import { IVerifiedEmailCommand } from "@/services/api/models/VerifiedEmailCommand.model";
import { IConfirmEmailCommand } from "@/services/api/models/ConfirmEmailCommand.model";
import { IForgotPasswordCommand } from "@/services/api/models/ForgotPasswordCommand.model";
import { IForgotPasswordOptionsCommand } from "@/services/api/models/ForgotPasswordOptionsCommand.model";
import { ForgotPasswordSecretQuestionVm } from "@/services/api/models/ForgotPasswordSecretQuestionVm.model";
import { IForgotPasswordSecretQuestionCommand } from "@/services/api/models/ForgotPasswordSecretQuestionCommand.model";
import { IForgotPasswordSecretQuestionAnswerCommand } from "@/services/api/models/ForgotPasswordSecretQuestionAnswerCommand.model";
import { IForgotPasswordSecretQuestionUpdateCommand } from "@/services/api/models/ForgotPasswordSecretQuestionUpdateCommand.model";
import { IForgotPasswordPinCommand } from "@/services/api/models/ForgotPasswordPinCommand.model";
import { IForgotPasswordPinAnswerCommand } from "@/services/api/models/ForgotPasswordPinAnswerCommand.model";
import { IForgotPasswordPinUpdateCommand } from "@/services/api/models/ForgotPasswordPinUpdateCommand.model";
import { IExistsDocumentationQuery } from "@/services/api/models/ExistsDocumentationQuery.model";
import { IForgotPasswordPersonalQuestionsUpdateCommand } from "@/services/api/models/ForgotPasswordPersonalQuestionsUpdateCommand.model";
import { IForgotPasswordConfirmationCommand } from "@/services/api/models/ForgotPasswordConfirmationCommand.model";
import { IValidateDocumentationQuery } from "@/services/api/models/ValidateDocumentationQuery.model";
import { IValidateCitizenCommand } from "@/services/api/models/ValidateCitizenCommand.model";
import { IValidatePassportCommand } from "@/services/api/models/ValidatePassportCommand.model";
import { LoginDto } from "@/services/api/models/LoginDto.model";
import { ProfileDto } from "@/services/api/models/ProfileDto.model";
import { TrivialDto } from "@/services/api/models/TrivialDto.model";
import { LoginViewModel } from "@/services/api/models/LoginViewModel.model";
import { ValidateCitizenDto } from "@/services/api/models/ValidateCitizenDto.model";
import { ValidatePassportDto } from "@/services/api/models/ValidatePassportDto.model";
import { IUpdateProfileDataCommand } from "@/services/api/models/UpdateProfileDataCommand.model";
import { IUpdatePinCommand } from "@/services/api/models/UpdatePinCommand.model";
import { IUpdateSecretQuestionCommand } from "@/services/api/models/UpdateSecretQuestionCommand.model";
import { IUpdateCedulaPhotoCommand } from "@/services/api/models/UpdateCedulaPhotoCommand.model";
import { IUpdatePassportPhotoCommand } from "@/services/api/models/UpdatePassportPhotoCommand.model";
import { IUpdateProfilePhotoCommand } from "@/services/api/models/UpdateProfilePhotoCommand.model";
import { IUpdateEmailVerifiedCommand } from "@/services/api/models/UpdateEmailVerifiedCommand.model";
import { IValidateProfileLawyerSignatureCommand } from "../models/ValidateProfileLawyerSignatureCommand.model";
import { IValidateProfileLawyerSignatureEmailCommand } from "../models/ValidateProfileLawyerSignatureEmailCommand.model";
import { IValidateProfileEmployeeBelongingCommand } from "../models/ValidateProfileEmployeeBelongingCommand.model";
import { IValidateProfileEmployeeBelongingEmailCommand } from "../models/ValidateProfileEmployeeBelongingEmailCommand.model";
import { IUpdateFacePassportCommand } from "../models/UpdateFacePassportCommand.model";
import { IValidateProfileLawyerCommand } from "../models/ValidateProfileLawyerCommand.model";
import { IForgotPasswordFacialRecognitionUpdateCommand } from "@/services/api/models/ForgotPasswordFacialRecognitionUpdateCommand.model";

class AccountApi extends Api {
  constructor(config: AxiosRequestConfig) {
    super(config);

    this.profile = this.profile.bind(this);
    this.updateProfile = this.updateProfile.bind(this);
    this.loginInfo = this.loginInfo.bind(this);
    this.login = this.login.bind(this);
    this.loginTwoFactor = this.loginTwoFactor.bind(this);
    this.register = this.register.bind(this);
    this.validateDocumentation = this.validateDocumentation.bind(this);
    this.validateCitizen = this.validateCitizen.bind(this);
    this.verifiedEmail = this.verifiedEmail.bind(this);
    this.confirmEmail = this.confirmEmail.bind(this);
    this.forgotPassword = this.forgotPassword.bind(this);
    this.forgotPasswordOptions = this.forgotPasswordOptions.bind(this);
    this.forgotPasswordSecretQuestion =
      this.forgotPasswordSecretQuestion.bind(this);
    this.forgotPasswordSecretQuestionAnswer =
      this.forgotPasswordSecretQuestionAnswer.bind(this);
    this.forgotPasswordSecretQuestionUpdate =
      this.forgotPasswordSecretQuestionUpdate.bind(this);
    this.forgotPasswordPin = this.forgotPasswordPin.bind(this);
    this.forgotPasswordPinAnswer = this.forgotPasswordPinAnswer.bind(this);
    this.forgotPasswordPinUpdate = this.forgotPasswordPinUpdate.bind(this);
    this.forgotPasswordPersonalQuestionsExists =
      this.forgotPasswordPersonalQuestionsExists.bind(this);
    this.forgotPasswordPersonalQuestionsUpdate =
      this.forgotPasswordPersonalQuestionsUpdate.bind(this);
    this.forgotPasswordConfirmation =
      this.forgotPasswordConfirmation.bind(this);
    this.updatePin = this.updatePin.bind(this);
    this.updateSecretQuestion = this.updateSecretQuestion.bind(this);
    this.updateCedulaPhoto = this.updateCedulaPhoto.bind(this);
    this.updatePassportPhoto = this.updatePassportPhoto.bind(this);
    this.updateEmailVerified = this.updateEmailVerified.bind(this);
    this.ValidateProfileLawyer = this.ValidateProfileLawyer.bind(this);
    this.ValidateProfileLawyerSignature =
      this.ValidateProfileLawyerSignature.bind(this);
    this.updateFacePassport = this.updateFacePassport.bind(this);
    this.ValidateProfileLawyerEmailSignature =
      this.ValidateProfileLawyerEmailSignature.bind(this);
    this.ValidateProfileEmployeeBelonging =
      this.ValidateProfileEmployeeBelonging.bind(this);
    this.ValidateProfileEmployeeBelongingEmail =
      this.ValidateProfileEmployeeBelongingEmail.bind(this);
    this.forgotPasswordFacialRecognition =
      this.forgotPasswordFacialRecognition.bind(this);
  }

  public profile(): Promise<ProfileDto> {
    return this.get("api/account").then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public updateProfile(
    data: IUpdateProfileDataCommand
  ): Promise<AxiosResponse<any>> {
    return this.post("api/account/update-profile", data).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public loginInfo(data: ILoginInfoCommand): Promise<LoginViewModel> {
    return this.post("api/Account/login-info", data).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public login(info: ILoginCommand): Promise<LoginDto> {
    return this.post("api/Account/login", info).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public loginTwoFactor(info: ILoginTwoFactorCommand): Promise<LoginDto> {
    return this.post("api/Account/login-two-factor", info).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public register(data: IRegisterCommand): Promise<AxiosResponse<any>> {
    return this.post("api/Account/register", data).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public validateDocumentation(
    data: IValidateDocumentationQuery
  ): Promise<TrivialDto> {
    return this.get(
      `api/Account/validate/${data.documentationType}/${data.documentId}`
    ).then((result: AxiosResponse<any>) => result.data);
  }

  public validateCitizen(
    data: IValidateCitizenCommand
  ): Promise<ValidateCitizenDto> {
    return this.post("api/Account/validate-citizen", data).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public validatePassport(
    data: IValidatePassportCommand
  ): Promise<ValidatePassportDto> {
    return this.post("api/Account/validate-passport", data).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public verifiedEmail(
    data: IVerifiedEmailCommand
  ): Promise<AxiosResponse<any>> {
    return this.post("api/Account/verified-email", data).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public confirmEmail(data: IConfirmEmailCommand): Promise<AxiosResponse<any>> {
    return this.post("api/Account/confirm-email", data).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public forgotPassword(
    data: IForgotPasswordCommand
  ): Promise<AxiosResponse<any>> {
    return this.post("api/Account/forgot-password", data).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public forgotPasswordOptions(
    data: IForgotPasswordOptionsCommand
  ): Promise<AxiosResponse<any>> {
    return this.post("api/Account/forgot-password-options", data).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public forgotPasswordSecretQuestion(
    data: IForgotPasswordSecretQuestionCommand
  ): Promise<ForgotPasswordSecretQuestionVm> {
    return this.post("api/Account/forgot-password-secret-question", data).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public forgotPasswordSecretQuestionAnswer(
    data: IForgotPasswordSecretQuestionAnswerCommand
  ): Promise<AxiosResponse<any>> {
    return this.post(
      "api/Account/forgot-password-secret-question-answer",
      data
    ).then((result: AxiosResponse<any>) => result.data);
  }

  public forgotPasswordSecretQuestionUpdate(
    data: IForgotPasswordSecretQuestionUpdateCommand
  ): Promise<AxiosResponse<any>> {
    return this.post(
      "api/Account/forgot-password-secret-question-update",
      data
    ).then((result: AxiosResponse<any>) => result.data);
  }

  public forgotPasswordPin(
    data: IForgotPasswordPinCommand
  ): Promise<AxiosResponse<any>> {
    return this.post("api/Account/forgot-password-pin", data).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public forgotPasswordPinAnswer(
    data: IForgotPasswordPinAnswerCommand
  ): Promise<AxiosResponse<any>> {
    return this.post("api/Account/forgot-password-pin-answer", data).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public forgotPasswordPinUpdate(
    data: IForgotPasswordPinUpdateCommand
  ): Promise<AxiosResponse<any>> {
    return this.post("api/Account/forgot-password-pin-update", data).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public forgotPasswordPersonalQuestionsExists(
    data: IExistsDocumentationQuery
  ): Promise<TrivialDto> {
    return this.get(
      `api/Account/forgot-password-personal-questions/${data.documentationType}/${data.documentId}`
    ).then((result: AxiosResponse<any>) => result.data);
  }

  public forgotPasswordPersonalQuestionsUpdate(
    data: IForgotPasswordPersonalQuestionsUpdateCommand
  ): Promise<AxiosResponse<any>> {
    return this.post(
      "api/Account/forgot-password-personal-questions-update",
      data
    ).then((result: AxiosResponse<any>) => result.data);
  }

  public forgotPasswordConfirmation(
    data: IForgotPasswordConfirmationCommand
  ): Promise<AxiosResponse<any>> {
    return this.post("api/Account/forgot-password-confirmation", data).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public updatePin(data: IUpdatePinCommand): Promise<AxiosResponse<any>> {
    return this.post("api/account/update-pin", data).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public updateProfilePhoto(
    data: IUpdateProfilePhotoCommand
  ): Promise<AxiosResponse<any>> {
    return this.post("api/account/update-profile-photo", data).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public updateSecretQuestion(
    data: IUpdateSecretQuestionCommand
  ): Promise<AxiosResponse<any>> {
    return this.post("api/account/update-secret-question", data).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public updateCedulaPhoto(
    data: IUpdateCedulaPhotoCommand
  ): Promise<AxiosResponse<any>> {
    return this.post("api/account/update-cedula-photo", data).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public updatePassportPhoto(
    data: IUpdatePassportPhotoCommand
  ): Promise<AxiosResponse<any>> {
    return this.post("api/account/update-passport-photo", data).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public updateEmailVerified(
    data: IUpdateEmailVerifiedCommand
  ): Promise<AxiosResponse<any>> {
    return this.post("api/account/update-email-verified", data).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public ValidateProfileLawyer(
    data: IValidateProfileLawyerCommand
  ): Promise<AxiosResponse<any>> {
    return this.get(`api/account/lawyer-validate/${data.id}`).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public ValidateProfileLawyerSignature(
    data: IValidateProfileLawyerSignatureCommand
  ): Promise<AxiosResponse<any>> {
    return this.get(`api/account/lawyer-signature-validate/${data.id}`).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public ValidateProfileLawyerEmailSignature(
    data: IValidateProfileLawyerSignatureEmailCommand
  ): Promise<AxiosResponse<any>> {
    return this.get(
      `api/account/lawyer-signature-validate-email/${data.id}`
    ).then((result: AxiosResponse<any>) => result.data);
  }

  public ValidateProfileEmployeeBelonging(
    data: IValidateProfileEmployeeBelongingCommand
  ): Promise<AxiosResponse<any>> {
    return this.get(`api/account/employee-belonging-validate/${data.id}`).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public ValidateProfileEmployeeBelongingEmail(
    data: IValidateProfileEmployeeBelongingEmailCommand
  ): Promise<AxiosResponse<any>> {
    return this.get(
      `api/account/employee-belonging-validate-email/${data.id}`
    ).then((result: AxiosResponse<any>) => result.data);
  }

  public updateFacePassport(
    data: IUpdateFacePassportCommand
  ): Promise<AxiosResponse<any>> {
    return this.post("api/account/update-face-passport", data).then(
      (result: AxiosResponse<any>) => result.data
    );
  }

  public forgotPasswordFacialRecognition(
    data: IForgotPasswordFacialRecognitionUpdateCommand
  ): Promise<AxiosResponse<any>> {
    return this.post(
      "api/Account/forgot-password-facil-recognition-update",
      data
    ).then((result: AxiosResponse<any>) => result.data);
  }
}

export const accountApi = new AccountApi(apiConfig);
